import { create } from 'zustand';
import { Profile, User } from 'common/types/api';
import { server } from 'common/services/server/server';

export type ProfileStore = {
  user: User | null;
  profile: Profile | null;
  userId: string;
  recommendedCourseId: string;
  setProfile: (profile: Profile) => void;
  setUserId: (userId: string) => void;
  setRecommendedCourseId: (userId: string) => void;
  verifyUser: () => Promise<void>;
};

const useProfileStore = create<ProfileStore>((set) => ({
  user: null,
  profile: null,
  userId: '',
  recommendedCourseId: '',
  setProfile: (profile) => set({ profile }),
  setUserId: (userId) => set({ userId }),
  setRecommendedCourseId: (recommendedCourseId) => set({ recommendedCourseId }),

  //
  verifyUser: async () => {
    try {
      const user = await server.getUser();
      set({ user });
    } catch {
      //
    }
  },
}));

export default useProfileStore;
